import Modal from 'react-modal';
import React from 'react';
import Link from 'shared/components/Link';
import { T } from 'shared/helper/translate';
import SubscriptionErrorMessage from './SubscriptionErrorMessage';
var ModalFlashMessage = function ModalFlashMessage(_ref) {
  var message = _ref.message,
    dismissMessage = _ref.dismissMessage;
  var handleDismissMessage = function handleDismissMessage() {
    dismissMessage();
    if (message.action && message.action.onClick) {
      message.action.onClick();
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    appElement: document.querySelector('#researcher-app'),
    isOpen: true,
    contentLabel: message.message,
    overlayClassName: "react-modal-overlay",
    className: "react-modal react-modal-alert react-modal-alert-".concat(message.type)
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "react-modal-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: message.type
  }))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content"
  }, message.customRender === 'subscriptionErrorWithLink' ? /*#__PURE__*/React.createElement(SubscriptionErrorMessage, {
    message: message,
    onLinkClick: message.onLinkClick
  }) : /*#__PURE__*/React.createElement(T.md, {
    source: message.message,
    params: message.params
  }), dismissMessage !== null ? /*#__PURE__*/React.createElement("div", null, message.action && message.action.link ? /*#__PURE__*/React.createElement(Link, {
    to: message.action.link,
    onClick: handleDismissMessage,
    className: "btn btn-squared"
  }, /*#__PURE__*/React.createElement(T, {
    source: message.action && message.action.text ? message.action.text : 'Close'
  })) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleDismissMessage,
    className: "btn btn-primary"
  }, /*#__PURE__*/React.createElement(T, {
    source: message.action && message.action.text ? message.action.text : 'Close'
  }))) : null));
};
export default ModalFlashMessage;